<template>
  <div class="col-md-6 col-12">
    <q-card flat square>
      <Info :message="title || $t('Common.ShippedTo.Text')"></Info>
      <div class="text q-ml-lg">
        <div v-if="recipientName" class="text-body1 text-primary-darkened text-uppercase">
          {{ recipientName }}
        </div>
        <div v-if="recipientEmail" class="text-subtitle1 text-primary-darkened">
          {{ recipientEmail }}
        </div>
        <div v-if="recipientPhone" class="text-subtitle2 q-mb-md text-primary">
          {{ recipientPhone }}
        </div>
        <div v-if="recipientAddress" class="text-caption text-uppercase" v-html="recipientAddress"></div>
      </div>
    </q-card>
  </div>
</template>
<script>
export default {
  name: 'ShippingRecipientInfo',
  props: {
    title: {},
    recipientName: {},
    recipientEmail: {},
    recipientPhone: {},
    recipientAddress: {},
  },
}
</script>
